/**
 * @fileoverview Which country an instructor teaches in: three equal buttons,
 * the chosen one pressed. Onboarding and Settings → Profile both ask it with
 * this control, as the iOS app asks it with its SegmentedControl in both
 * places. The country only picks the region list; the region itself is
 * stored in the user's `state` field.
 */

import { COUNTRY_OPTIONS } from "@/data/locations";

/**
 * @param {object} props
 * @param {"US"|"AU"|"other"} props.value The chosen country.
 * @param {function(string): void} props.onChange Called with a country id on every press.
 * @param {string} props.labelledBy The id of the visible label that names the group.
 * @param {string} [props.testId]
 */
export default function CountryChoice({ value, onChange, labelledBy, testId }) {
  return (
    <div className="grid grid-cols-3 gap-2" role="group" aria-labelledby={labelledBy} data-testid={testId}>
      {COUNTRY_OPTIONS.map((c) => (
        <button
          key={c.id}
          type="button"
          onClick={() => onChange(c.id)}
          aria-pressed={value === c.id}
          className={[
            "rounded-xl border px-2 py-2.5 text-sm transition-colors",
            value === c.id
              ? "border-[var(--accent-yellow-border)] bg-[var(--accent-yellow-dim)] text-[var(--accent-yellow-text)]"
              : "border-[var(--studio-divider-strong)] text-[var(--text-secondary)] hover:bg-[var(--studio-raised)]",
          ].join(" ")}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
